import React from 'react';
import { useSelector } from 'react-redux';
import { Box, useTheme } from '@mui/material';
import { RootState } from '../../reducers';
import MultiAskAI from '../library/files/MultiAskAI';
import { DRAWER_WIDTH } from '../../constants/ui';

interface Props {
  open: boolean;
  onClose: () => void;
}

const MultiAskAIManager: React.FC<Props> = ({ open, onClose }) => {
  const theme = useTheme();
  const drawerOpen = useSelector(
    (state: RootState) => state.dashboard.drawerState === 'open'
  );

  if (!open) return null;

  return (
    <Box
      sx={{
        position: 'fixed',
        top: {
          xs: 56, // Height of toolbar on mobile
          sm: 64, // Height of toolbar on desktop
        },
        left: {
          xs: 0,
          sm: drawerOpen ? DRAWER_WIDTH : theme.spacing(7),
        },
        right: 0,
        bottom: 0,
        bgcolor: 'background.default',
        zIndex: {
          xs: theme.zIndex.drawer - 1, // Below drawer on mobile
          sm: theme.zIndex.drawer - 1,
        },
        transition: theme.transitions.create(['left']),
        width: {
          xs: '100%',
          sm: `calc(100% - ${drawerOpen ? DRAWER_WIDTH : theme.spacing(7)}px)`,
        },
      }}
    >
      <MultiAskAI open={open} onClose={onClose} />
    </Box>
  );
};

export default MultiAskAIManager;
